<template>
  <span class="spinner-border spinner-border-sm"></span>
</template>
<script>
export default {
  name: "Spinner",
};
</script>
